import { useState } from "react";

import { Form, Select, message, Tag } from "antd";

import { useAppSelector } from "store";
import { getUserSelector } from "store/user/user.selector";
import { isValidEmail } from "helpers/fieldValidation";
import emailIcon from "data/icons/email.svg";
import emailIconGray from "data/icons/email-gray.svg";

interface IProps {
  clientsCopy: any[];
  getClientsCopy: (value: string) => void;
}

const CaseCCField = ({ clientsCopy, getClientsCopy }: IProps) => {
  const { isAuthorized } = useAppSelector(getUserSelector);
  const [ currentValues, setCurrentValues ] = useState<string[]>([]);

  const isValueValid = (value: string): boolean => {
    const isExistingOption = clientsCopy.some(client => client.email === value);
    return isExistingOption || isValidEmail(value);
  };

  const handleChange = (values: string[]) => {
    if (values.length > currentValues.length) {
      const newValue = values.find(value => !currentValues.includes(value));
      
      if (newValue) {
        const isExistingOption = clientsCopy.some(client => client.email === newValue);
        
        if (!isExistingOption && !isValidEmail(newValue)) {
          message.error("Please enter a valid email address. This value will be ignored while submitting.");
          return currentValues;
        }
      }
    }
    
    setCurrentValues(values);
    return values;
  };

  const tagRender = ({ value, closable, onClose }: { value: string; closable?: boolean; onClose?: () => void }) => {
    const isValid = isValueValid(value);
    
    return (
      <Tag
        closable={ closable }
        onClose={ onClose }
        style={ {
          backgroundColor: isValid ? "#f0f0f0" : "#ffebee",
          borderColor: isValid ? "#d9d9d9" : "#ff4d4f",
          color: isValid ? "#000000d9" : "#ff4d4f",
        } }
      >
        { value }
      </Tag>
    );
  };

  return (
    <div className="cc-info">
      <div className="case-form-group-title">
        <div>
          <img
            alt=""
            src={ emailIcon }
            style={ { marginRight: 5 } }
          />
          Cc
        </div>
      </div>

      <Form.Item
        label=""
        name="email_cc"
        style={ { flex: 1 } }
      >
        <Select
          mode="tags"
          value={ currentValues }
          tagRender={ tagRender }
          options={ isAuthorized ? clientsCopy.map(client => ({
            value: client.email,
            label: (
              <div>
                <div style={ { color: "#0C758C" } }>
                  { client.label } { client.lastName }
                </div>

                <div
                  style={ {
                    fontSize: "12px",
                    lineHeight: "14px",
                    marginBottom: "2px",
                    color: "#769197",
                  } }
                >
                  <img
                    alt=""
                    style={ { marginBottom: "-1px" } }
                    src={ emailIconGray }
                  /> { client.email }
                </div>
              </div>
            ),
            label2: (
              <div className="cc-list-label">
                <div className="cc-list-label-name">
                  { client.label } { client.lastName }
                </div>

                <div className="cc-list-label-email">
                  { client.email }
                </div>
              </div>
            ),
          })) : undefined }
          optionLabelProp="label2"
          onSearch={ (value) => {
            if (isAuthorized) {
              getClientsCopy(value);
            }
          } }
          filterOption={ false }
          placeholder="Name or email"
          notFoundContent={ null }
          dropdownStyle={ { visibility: isAuthorized ? "visible" : "hidden" } }
          onChange={ handleChange }
        />
      </Form.Item>
    </div>
  );
};

export default CaseCCField;
